import React, {forwardRef} from 'react';
import clsx from 'clsx';
import {Typography} from 'onboarding-components';

import styles from './index.module.styl';

type TileButtonBase = {
  selected?: boolean;
  fullWidthOnMobile?: boolean;
  badge?: React.ReactNode;
};

type ButtonProps = TileButtonBase & React.ButtonHTMLAttributes<HTMLButtonElement>;

export const TileButton = forwardRef(function TileButtonBase(
  {className, children, onClick, badge, selected = false, fullWidthOnMobile = false, ...rest}: ButtonProps,
  ref,
) {
  return (
    <button
      ref={ref as unknown as React.Ref<HTMLButtonElement>}
      className={clsx(styles.bubbleOption, className, {
        [styles.optionFullWidth]: fullWidthOnMobile,
        [styles.selected]: selected,
      })}
      onClick={onClick}
      {...rest}
    >
      <Typography weight='bold' variant='captionSm' className={styles.text}>
        {children}
      </Typography>
      {badge}
    </button>
  );
});
